// extracted by mini-css-extract-plugin
module.exports = {"title":"footerLinkList_title__2vdgV","list":"footerLinkList_list__3ipTX","blockList":"footerLinkList_blockList__2WU8b"};
    if(module.hot) {
      // 1790670281209
      var cssReload = require("!../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  